import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import {formatToExponential} from "../../../../helpers/NumberHelper";

const defaultIndicators = {
    filamentVoltage: "---",
    filamentCurrent: "---",
    primaryDCVoltage: "---",
    pulseWidth: "---",
    averagePower: "---",
    pulseRepetitionFrequency: "---",
    arcCount: "---"
};

export default function ScandinovaM1ReadBack({pipe, data}) {
    const indicators = data
        ? Object.assign(defaultIndicators, {
            filamentVoltage: data["filament_voltage"],
            filamentCurrent: data["filament_current"],
            primaryDCVoltage: data["primary_dc_voltage"],
            pulseWidth: data["pulse_width"],
            averagePower: data["average_power"],
            pulseRepetitionFrequency: data["pulse_repetition_frequency"],
            arcCount: data["arc_count"]
        }) : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                    <Grid item>
                        <TextField
                            id="filament-voltage"
                            label="Filament Voltage"
                            value={formatToExponential(indicators.filamentVoltage)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="filament-current"
                            label="Filament Current"
                            value={formatToExponential(indicators.filamentCurrent)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="primary-dc-voltage"
                            label="Primary DC Voltage"
                            value={formatToExponential(indicators.primaryDCVoltage)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="pulse-width"
                            label="Pulse Width"
                            value={formatToExponential(indicators.pulseWidth)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="average-power"
                            label="Average Power"
                            value={formatToExponential(indicators.averagePower)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="pulse-repetition-frequency"
                            label="Pulse Repetition Frequency"
                            value={formatToExponential(indicators.pulseRepetitionFrequency)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="arc-count"
                            label="Arc Count"
                            value={formatToExponential(indicators.arcCount)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                </Grid>
            }
        />
    );
}